import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// CoreUI
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from './assets/icons'
import '@coreui/coreui/dist/css/coreui.min.css'

// Estilos personalizados
import './assets/css/sidebar.css'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)

app.mount('#app')